import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';
export default defineComponent({
    name: 'customer-feed-back-slider',
    components: {
        Carousel,
        Slide,
        Pagination,
        Navigation,
    },
    props: {
        slides: {
            type: Object,
            required: true,
        },
    },
    data: () => ({}),
    computed: Object.assign({}, mapGetters('global', {
        isMobile: 'isMobile',
    })),
});
